<template>
  <main id="js-page-content" role="main" class="page-content">
    <ol class="breadcrumb page-breadcrumb">
      <li class="breadcrumb-item">
        <a href="javascript:void(0);">SmartAdmin</a>
      </li>
      <li class="breadcrumb-item">Category</li>
      <li class="breadcrumb-item">Sub-category</li>
      <li class="breadcrumb-item active">Page Title</li>
      <li class="position-absolute pos-top pos-right d-none d-sm-block">
        <span class="js-get-date"></span>
      </li>
    </ol>
    <div class="subheader">
      <h1 class="subheader-title">
        <i class="subheader-icon fal fa-globe"></i> Modal
        <span class="fw-300">サンプル</span>
        <sup class="badge badge-primary fw-500">STICKER</sup>
        <small> Insert page description or punch line </small>
      </h1>
      <!-- 
		Right content on content header
		A nice area to add graphs or buttons -->
      <div class="subheader-block">Right Subheader Block</div>
    </div>

    <div class="alert alert-primary">
      <div class="d-flex flex-start w-100">
        <div class="mr-2 hidden-md-down">
          <span class="icon-stack icon-stack-lg">
            <i
              class="base base-6 icon-stack-3x opacity-100 color-primary-500"
            ></i>
            <i
              class="base base-10 icon-stack-2x opacity-100 color-primary-300 fa-flip-vertical"
            ></i>
            <i
              class="ni ni-blog-read icon-stack-1x opacity-100 color-white"
            ></i>
          </span>
        </div>
        <div class="d-flex flex-fill">
          <div class="flex-fill">
            <span class="h5">注意事項!</span>
            <p>特に注意事項はないです</p>
            <p class="m-0">
              Follow a slogal with a useful link or call to action
              <a href="#" target="_blank">Call to action >></a>
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>modal</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    各モーダルはコンポーネント化している
                  </div>
                  <button
                    @click="showModal()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_l表示
                  </button>
                  <button
                    @click="showModal_n()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_n表示
                  </button>
                  <button
                    @click="showModal_s()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_s表示
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>modal-left</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    各モーダルはコンポーネント化している
                  </div>
                  <button
                    @click="showModal_left()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_left_l表示
                  </button>
                  <button
                    @click="showModal_left_n()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_left_n表示
                  </button>
                  <button
                    @click="showModal_left_s()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_left_s表示
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div id="panel-x" class="panel">
          <div class="panel-hdr">
            <h2>modal-alert</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
              <button
                class="btn btn-panel waves-effect waves-themed"
                data-action="panel-close"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Close"
              ></button>
            </div>
          </div>
          <div class="panel-container show">
            <div class="panel-content">
              <div class="frame-wrap">
                <div class="demo">
                  <div class="panel-tag">
                    各モーダルはコンポーネント化している
                  </div>
                  <button
                    @click="showModal_alert()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_alert表示
                  </button>
                  <button
                    @click="showModal_alert2()"
                    type="button"
                    class="btn btn-primary waves-effect waves-themed"
                  >
                    Mo_modal_alert2表示
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 以下モーダルコンポーネント本体 -->
    <!-- modal1 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_l ref="Mo_modal_l">
      <template v-slot:title>モーダルのタイトル</template>
      <template v-slot:body>モーダルのボディの内容</template>
      <template v-slot:footer>
        <button
          @click="closeModal()"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          @click="save()"
          type="button"
          class="btn btn-primary waves-effect waves-themed"
        >
          Save changes
        </button>
      </template>
    </Mo_modal_l>
    <!-- /modal1 -->
    <!-- modal2 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_n ref="Mo_modal_n">
      <template v-slot:title>モーダルのタイトル</template>
      <template v-slot:body>モーダルのボディの内容</template>
      <template v-slot:footer>
        <button
          @click="closeModal_n()"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          @click="save_n()"
          type="button"
          class="btn btn-primary waves-effect waves-themed"
        >
          Save changes
        </button>
      </template>
    </Mo_modal_n>
    <!-- /modal2 -->
    <!-- modal3 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_s ref="Mo_modal_s">
      <template v-slot:title>モーダルのタイトル</template>
      <template v-slot:body>モーダルのボディの内容</template>
      <template v-slot:footer>
        <button
          @click="closeModal_s()"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          @click="save_s()"
          type="button"
          class="btn btn-primary waves-effect waves-themed"
        >
          Save changes
        </button>
      </template>
    </Mo_modal_s>
    <!-- /modal3 -->

    <!-- modal4 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_left_s ref="Mo_modal_left_s">
      <template v-slot:title>左モーダルのタイトル</template>
      <template v-slot:body>モーダルのボディの内容</template>
      <template v-slot:footer>
        <button
          @click="closeModal_left_s()"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          @click="save_left_s()"
          type="button"
          class="btn btn-primary waves-effect waves-themed"
        >
          Save changes
        </button>
      </template>
    </Mo_modal_left_s>
    <!-- /modal4 -->
    <!-- modal5 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_left_l ref="Mo_modal_left_l">
      <template v-slot:title>モーダルのタイトル</template>
      <template v-slot:body>モーダルのボディの内容</template>
      <template v-slot:footer>
        <button
          @click="closeModal()"
          type="button"
          class="btn btn-secondary waves-effect waves-themed"
          data-dismiss="modal"
        >
          Close
        </button>
        <button
          @click="save()"
          type="button"
          class="btn btn-primary waves-effect waves-themed"
        >
          Save changes
        </button>
      </template>
    </Mo_modal_left_l>
    <!-- /modal5 -->
    <!-- modal6 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_left_n ref="Mo_modal_left_n">
      <template v-slot:title>モーダルのタイトル</template>
      <template v-slot:body>
        <div class="card mb-5">
          <div class="card-body p-3">
            <h5>
              ADP System Migration
              <small class="mt-0 mb-3 text-muted">
                Migration of new API to local servers
              </small>
              <span
                class="badge badge-primary fw-n position-absolute pos-top pos-right mt-3 mr-3"
                >A</span
              >
            </h5>
            <div class="row fs-b fw-300">
              <div class="col text-left">Progress</div>
              <div class="col text-right">90%</div>
            </div>
            <div class="progress progress-xs d-flex mb-2 mt-1">
              <span
                class="progress-bar bg-primary-500 progress-bar-striped"
                role="progressbar"
                style="width: 90%"
                aria-valuenow="90"
                aria-valuemin="0"
                aria-valuemax="100"
              ></span>
            </div>
            <div class="fw-300 mb-0">
              <div class="row">
                <div class="col">Budget</div>
                <div class="col text-right">$1,325,987.30</div>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-g">
          <div class="card-body p-3">
            <h5 class="text-danger">
              ADP System Migration
              <small class="mt-0 mb-3 text-muted">
                Migration of new API to local servers
              </small>
              <span
                class="badge badge-danger fw-n position-absolute pos-top pos-right mt-3 mr-3"
                >Delayed</span
              >
            </h5>
            <div class="row fs-b fw-300">
              <div class="col text-left">Progress</div>
              <div class="col text-right">26%</div>
            </div>
            <div class="progress progress-xs d-flex mb-2 mt-1">
              <span
                class="progress-bar bg-danger-500 progress-bar-striped"
                role="progressbar"
                style="width: 26%"
                aria-valuenow="26"
                aria-valuemin="0"
                aria-valuemax="100"
              ></span>
            </div>
            <div class="fw-300 mb-3">
              <div class="row">
                <div class="col">Budget</div>
                <div class="col text-right text-danger">-$155,473.70</div>
              </div>
            </div>
            <div class="fs-xs mb-3 fw-300">
              <ul class="list-unstyled mb-1">
                <li>
                  <i class="fal fa-circle text-muted"></i>
                  <span class="text-muted"><s> Heated maps generated</s></span>
                </li>
                <li>
                  <i class="fal fa-circle text-danger"></i> Turncated syndicate
                  rated
                </li>
                <li>
                  <i class="fal fa-dot-circle text-danger"></i> ADP forms needs
                  approval and review
                </li>
                <li>
                  <i class="fal fa-exclamation-triangle text-danger"></i> Bug
                  review
                </li>
              </ul>
            </div>
            <div class="text-left fw-400">
              <div class="text-secondary mb-1">Project Owners</div>
              <div class="fs-sm d-flex align-items-center">
                <a href="#" class="btn-m-s">
                  <img
                    src="img/demo/avatars/avatar-a.png"
                    class="profile-image-sm rounded-circle"
                    alt="aa"
                  />
                </a>
                <a href="#" class="btn-m-s">
                  <img
                    src="img/demo/avatars/avatar-b.png"
                    class="profile-image-sm rounded-circle"
                    alt="aa"
                  />
                </a>
                <a href="#" class="btn-m-s">
                  <img
                    src="img/demo/avatars/avatar-c.png"
                    class="profile-image-sm rounded-circle"
                    alt="aa"
                  />
                </a>
                <a href="#" class="btn-m-s">
                  <img
                    src="img/demo/avatars/avatar-e.png"
                    class="profile-image-sm rounded-circle"
                    alt="aa"
                  />
                </a>
                <a href="#" class="btn-m-s">
                  <img
                    src="img/demo/avatars/avatar-h.png"
                    class="profile-image-sm rounded-circle"
                    alt="aa"
                  />
                </a>
                <a href="#" class="btn-m-s">
                  <img
                    src="img/demo/avatars/avatar-k.png"
                    class="profile-image-sm rounded-circle"
                    alt="aa"
                  />
                </a>
                <a href="#" class="btn-m-s fs-xs">
                  <span
                    data-hasmore="+7"
                    class="rounded-circle profile-image-sm"
                  >
                    <img
                      src="img/demo/avatars/avatar-j.png"
                      class="profile-image-sm rounded-circle"
                      alt="aa"
                    />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="card mb-g">
          <div class="card-body p-3">
            <h5 class="text-success">
              ADP System Migration
              <small class="mt-0 mb-3 text-muted">
                Migration of new API to local servers
              </small>
              <span
                class="badge badge-success fw-n position-absolute pos-top pos-right mt-3 mr-3"
                >D</span
              >
            </h5>
            <div class="row fs-b fw-300 text-secondar">
              <div class="col text-left">COMPLETE</div>
            </div>
            <div class="progress progress-xs d-flex mb-2 mt-1">
              <span
                class="progress-bar bg-success-500 progress-bar-striped"
                role="progressbar"
                style="width: 100%"
                aria-valuenow="100"
                aria-valuemin="0"
                aria-valuemax="100"
              ></span>
            </div>
            <div class="fw-300 mb-3">
              <div class="row">
                <div class="col">Budget</div>
                <div class="col text-right">$134</div>
              </div>
            </div>
            <div class="row">
              <div class="col text-right">
                <a
                  href="#"
                  class="btn btn-default btn-sm waves-effect waves-themed"
                  >APPROVE</a
                >
                <a
                  href="#"
                  class="btn btn-default btn-sm waves-effect waves-themed"
                  >DECLINE</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer> </template>
    </Mo_modal_left_n>
    <!-- /modal6 -->
    <!-- modal7 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_alert ref="Mo_modal_alert">
      <template v-slot:title>
        <i class="fal fa-times-circle text-danger mr-2"></i
        >XXXXXXXを削除します。よろしいですか？
      </template>
      <template v-slot:body>削除したデータは復旧できません</template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button type="button" class="btn btn-danger shadow-0 bootbox-accept">
            Yes</button
          ><button type="button" class="btn btn-default bootbox-cancel">
            No
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- /modal7 -->
    <!-- modal8 -->
    <!--
       modalにはスロットがあるので以下のように使用 
    ボタンのクリックイベントは、親コンポーネント（このコンポーネント）で発生するので、
    処理は親コンポーネント（このコンポーネント）に記載する。
    -->
    <Mo_modal_alert ref="Mo_modal_alert2">
      <template v-slot:title>
        <i class="fal fa-check-circle text-success mr-2"></i>
        <span class="text-success fw-500">Success!</span>
      </template>
      <template v-slot:body>削除しました</template>
      <template v-slot:footer>
        <div class="modal-footer">
          <button
            @click="closeModal_alert2()"
            type="button"
            class="btn btn-primary shadow-0 bootbox-accept"
          >
            Yes
          </button>
        </div>
      </template>
    </Mo_modal_alert>
    <!-- /modal8 -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Mo_modal_l from "@/components/molecules/Mo_modal_l.vue";
import Mo_modal_n from "@/components/molecules/Mo_modal_n.vue";
import Mo_modal_s from "@/components/molecules/Mo_modal_s.vue";
import Mo_modal_left_s from "@/components/molecules/Mo_modal_left_s.vue";
import Mo_modal_left_l from "@/components/molecules/Mo_modal_left_l.vue";
import Mo_modal_left_n from "@/components/molecules/Mo_modal_left_n.vue";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    Mo_modal_l,
    Mo_modal_n,
    Mo_modal_s,
    Mo_modal_left_s,
    Mo_modal_left_l,
    Mo_modal_left_n,
    Mo_modal_alert,
  },
})
export default class Modal extends Vue {
  // Mo_modal_l
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_l;
    modalComp.showModal();
  }
  async closeModal(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_l;
    modalComp.closeModal();
  }
  async save(): Promise<void> {
    alert("save");
  }
  //------------------------
  // Mo_modal_n
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_n(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_n;
    modalComp.showModal();
  }
  async closeModal_n(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_n;
    modalComp.closeModal();
  }
  async save_n(): Promise<void> {
    alert("save_n");
  }
  //------------------------
  // Mo_modal_s
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_s(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_s;
    modalComp.showModal();
  }
  async closeModal_s(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_s;
    modalComp.closeModal();
  }
  async save_s(): Promise<void> {
    alert("save_s");
  }
  //------------------------
  //------------------------
  // Mo_modal_left_s
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_left_s(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_left_s;
    modalComp.showModal();
  }
  async closeModal_left_s(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_left_s;
    modalComp.closeModal();
  }
  async save_left_s(): Promise<void> {
    alert("save_s");
  }
  //------------------------
  //------------------------
  // Mo_modal_left_l
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_left(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_left_l;
    modalComp.showModal();
  }
  async closeModal_left(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_left_l;
    modalComp.closeModal();
  }
  async save_left(): Promise<void> {
    alert("save_l");
  }
  //------------------------
  //------------------------
  // Mo_modal_left_n
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_left_n(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_left_n;
    modalComp.showModal();
  }
  async closeModal_left_n(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_left_n;
    modalComp.closeModal();
  }
  async save_left_n(): Promise<void> {
    alert("save_n");
  }
  //------------------------
  //------------------------
  // Mo_modal_alert
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_alert(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_alert;
    modalComp.showModal();
  }
  async closeModal_alert(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_alert;
    modalComp.closeModal();
  }
  async save_alert(): Promise<void> {
    alert("save_alert");
  }
  //------------------------
  //------------------------
  // Mo_modal_alert2
  //------------------------
  /**
   * vue-property-decoratorを入れて、propを使用したが、うまく動かなかった。
   * refsでコンポーネント内のメソッドを操作する方向で使用する。
   */
  async showModal_alert2(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_alert2;
    modalComp.showModal();
  }
  async closeModal_alert2(): Promise<void> {
    const modalComp: any = this.$refs.Mo_modal_alert2;
    modalComp.closeModal();
  }
  async save_alert2(): Promise<void> {
    alert("save_alert");
  }
  //------------------------
}
</script>
